export default class Modal {
  constructor(component = {}, options = {}) {
    this.options = options;
    this.el = component.el;
    this.modalInner = this.el.querySelector('[data-modal-inner]');
    this.contents = this.el.querySelector('[data-modal-contents]');
    this.mobileFriendly = 'modalMobileFriendly' in this.el.dataset;

    document.querySelector('[data-modal-close]').addEventListener('click', () => this.close());

    this.selectors = {
      open: 'modal-opened',
      visible: 'modal-visible',
      active: 'modal-active',
      scrollLock: 'scroll-locked',
    };

    const defaultCallbacks = {
      onOpen: () => ({}),
      onClose: () => ({}),
    };

    this.callbacks = {
      ...defaultCallbacks,
      ...component.callbacks,
    };
  }

  // Manually open a modal.
  open() {
    this.el.classList.add(this.selectors.open);
    window.addEventListener('resize', () => this._resize());

    // Use onOpen to insert contents into modal
    return this.callbacks.onOpen({
      modal: this.el,
      contents: this.contents,
    });
  }

  // Close modal, and clean up
  close() {
    this.el.classList.remove(this.selectors.active);
    this.el.classList.remove(this.selectors.visible);
    this.el.classList.remove(this.selectors.open);

    document.body.classList.remove(this.selectors.scrollLock);

    this.contents.innerHTML = '';

    this.callbacks.onClose();
    window.removeEventListener('resize', () => this._resize());
  }

  /*
            Make a modal visible after content has been added
            */
  showModal() {
    // Wait on animation frame after opening to ensure animations are played
    window.requestAnimationFrame(() => {
      document.body.classList.add(this.selectors.scrollLock);

      if (this.options && this.options.reposition && this.options.reposition !== false) {
        this._position();
      }

      this.el.addEventListener('transitionend', () => this.el.classList.add(this.selectors.active));
      this.el.classList.add(this.selectors.visible);
    });
  }

  _resize() {
    if (this.options && this.options.reposition && this.options.reposition !== false) {
      this._position();
    }
  }

  /*
            Center modal vertically and horizontally
            */
  _position() {
    const { width, height } = this.modalInner.getBoundingClientRect();

    this.modalInner.style.marginTop = `${-(height / 2)}px`;
    this.modalInner.style.marginLeft = `${-(width / 2)}px`;
  }
}
